

// 发布面试题相关请求
import request from '@/utils/request'

// 查询面试题
export const queryBankContent=(questData)=>{
    return request.post(
        '/questionBand/queryBankContent',
        questData
    )
}

// 判断当前记录是否需要积分
export const contentWhetherNeedPrice=(needPrice)=>{
    return request.post(
        '/questionBand/contentWhetherNeedPrice',
        needPrice
    )
}

// 调用接口，判断当前用户积分是否充足，充足则进行跳转，不充足，进行提示
export const priceAmple =(apmleData)=>{
    return request.post(
        '/questionBand/priceAmple',
        apmleData
    )
}